import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { YhBox } from "@/components/YhBox";
import { useGlobalModel, transPgToPagination } from "@/model/globalModel";
import { YhBut } from "@/components/YhButton";
import { RouterParamType } from "@/model/navModel";
import { IMaterialDetail, IMaterialSearch, materialService } from "@/views/base/material/materialService";
import { ISearchPage } from "@/types/AppTypes";
import { OPT_TYPE } from "@/types/AppEnums";
import { formatInt } from "@/utils/utils";
import { useSalesDetailModel } from "../salesDetailModel";


export const MaterialDiolog: FC<RouterParamType> = ({ id, mode }) => {
    const { user } = useGlobalModel(({ user }) => [user]);
    const { materialDialog: visible, setMaterialDialog, insertMaterial } = useSalesDetailModel(({ materialDialog }) => [materialDialog])
    //查询条件
    const [searchParam, setSearchParam] = useState<IMaterialSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IMaterialDetail[]>([]);
    const [selectMaterial, setSelectMaterial] = useState<IMaterialDetail[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoadding] = useState<boolean>(false);

    useEffect(() => {
        if (visible) {
            loadData()
        } else {
            setSelectMaterial([]);
        };
    }, [visible])

    const onCancel = () => {
        setMaterialDialog(false);
    };

    let loadData = async (page?: ISearchPage) => {
        setLoadding(true);
        try {
            const searchParams = {
                shopCode: user.shopCode,
                ...searchParam,
                status: "1",
                pageSize: page?.pageSize ?? pgCfg.pageSize,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current
            }
            let { retData } = await materialService.page(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            setLoadding(false);
        } catch (err) { setLoadding(false) }
    }

    const column = (optype: number) => [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '商品编号',
            width: 140,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'name',
            fixed: "left",
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'nameEn',
            fixed: "left",
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '规格型号',
            width: 100,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, 
        optype === OPT_TYPE.ADD ? {} : {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        }, {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: IMaterialDetail) => optype === OPT_TYPE.ADD ?
                <YhBut
                    type="add"
                    txt="添加"
                    disabled={!!selectMaterial.find(item => item.id === record.id)}
                    click={() => {
                        //添加配件，  数量默认为0
                        setSelectMaterial(origin => [...origin, { ...record, num: 1 }])
                    }}
                />
                :
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => {
                        //删除对应配件
                        setSelectMaterial(origin => origin.filter(item => item.id !== record.id))
                    }}
                />
        }
    ];

    const newSelectColumns = column(OPT_TYPE.REMOVE).map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IMaterialDetail, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IMaterialDetail) => {
        row.num = +formatInt(row.num);
        let dataSource = [...selectMaterial];
        const index = dataSource.findIndex((item) => row.id === item.id);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setSelectMaterial(dataSource);
    }

    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16"
            placeholder="商品编号/商品名称"
            value={searchParam?.codeOrName}
            onChange={(e) => setSearchParam({ codeOrName: e.target.value })}
            onPressEnter={() => loadData(initPgCfg)}
        />
        <Button style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => loadData(initPgCfg)}>检索</Button>
    </div >


    return <YHModal
        visible={visible}
        okText="确认添加"
        onOk={() => insertMaterial(mode, selectMaterial)}
        onCancel={onCancel}
        title="外贸合同--选择配件"
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                loading={loading}
                rowKey={record => record.id}
                columns={column(OPT_TYPE.ADD) as ColumnsType<IMaterialDetail>}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                rowKey={record => record.id}
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<IMaterialDetail>}
                dataSource={selectMaterial}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}